/* eslint-disable react/prop-types */
import { Box, Typography } from "@mui/material";
import React, { useState, useEffect } from "react";
import * as Sentry from "@sentry/react";
import Gohonzon from "../../services/api/gohonzon";
import { debounce, isEmptyObj } from "../../utils/helper";
import Button from "../common/Button";
import Modal from "../common/Modal/Modal";
import InputField from "../common/new/InputField/InputField";
import RemarksList from "../common/new/RemarksList/RemarksList";
import styles from "./styles";
import { AlertStatus } from "../../contants";

function CancelGohonzonApplicationModal({
  application,
  open,
  onClose,
  toast,
  refreshList,
}) {
  const [remarks, setRemarks] = useState([]);
  const [remark, setRemark] = useState("");

  const onReject = async () => {
    try {
      const body = {
        data: {
          message: remark,
        },
      };
      await Gohonzon.gohonzonHandoverCancelAllotmentRequest(
        body,
        application.memberId,
        application.id
      );
      toast.show("Cancelled Successfully", AlertStatus.SUCCESS);
      setTimeout(() => {
        onClose();
        refreshList();
      }, 2000);
    } catch (error) {
      toast.show(error.message, AlertStatus.ERROR);
      Sentry.captureException(error);
    }
  };

  const fetchRemarks = async (id) => {
    try {
      const result = await Gohonzon.getRemarks(id);
      setRemarks(result.data);
    } catch (error) {
      Sentry.captureException(error);
    }
  };

  useEffect(() => {
    if (!isEmptyObj(application)) {
      fetchRemarks(application.id);
    }
  }, [application]);

  return (
    <Modal open={open} onClose={onClose}>
      <div>
        {/* <Formik> */}
        <Box style={{ paddingBottom: "5px" }}>
          <Typography
            style={{
              color: "#8C8C8C",
              fontSize: "20px ",
              fontWeight: "500",
            }}
          >
            Cancel Gohonzon Application
          </Typography>
        </Box>
        <Box
          display="flex"
          flexDirection="row"
          justifyContent="flex-end"
          padding="15px 0px 15px 0px"
        />
        <div>
          <InputField
            // variant="outlined"
            type="text"
            defaultValue=""
            key="remark"
            name="remark"
            label="Enter your remark here..."
            style={styles.inputStyle}
            value={remark}
            onChange={(e) => setRemark(e.target.value)}
            InputProps={{ sx: { minHeight: "91px" } }}
          />
        </div>
        <div>
          <RemarksList remarks={remarks} />{" "}
        </div>
        <div style={{ display: "flex" }}>
          <Button
            variant="contained"
            style={styles.buttonStyle}
            onClick={debounce(() => {
              if (!remark) {
                toast.show("Remarks should not be empty!", AlertStatus.ERROR);
              } else {
                onReject();
              }
            })}
            type="submit"
            label="CANCEL APPLICATION"
          />
        </div>
      </div>
    </Modal>
  );
}

export default CancelGohonzonApplicationModal;
